/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react'
import { ILayout, useLayout } from '../../core'

const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='order-2 order-md-1'>
        <span className=' fw-semibold me-1 ' style={{ color: '#48708A' }}>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <a href='#' target='_blank' className=' text-hover-primary' style={{ color: '#48708A' }}>
          NEXO
        </a>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
        <li className='menu-item'>
          <a href='#' target='_blank' className='menu-link px-2' style={{ color: '#48708A' }}>
            Design & développement par <span className=' fw-bold ms-1' style={{ color: '#F68D2E' }}>
              <a href='https://vaerdia.com/'>VAERDIA</a>
            </span>
          </a>
        </li>
      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
